import { Dialog } from "primereact/dialog";
import React from "react";
import DeviceManagerActionForm from "./DeviceManagerActionForm";

function DeviceManagerAction({ data, showModal, onCloseModal }) {
    if (data === null) {
        return null;
    }
    return (
        <Dialog visible={showModal} style={{ width: "50vw" }} onHide={onCloseModal}>
            <DeviceManagerActionForm data={data} onCloseModal={onCloseModal} />
        </Dialog>
    );
}

export default DeviceManagerAction;
